/** Layer list label for a Fabric object */
export function objectLayerLabel(obj) {
  if (!obj || obj.ignore) return null;
  const label = obj.niceName || obj.name || obj.type || 'Object';
  return String(label).replace(/button (rect|circle|ellipse) (\d+)/i, 'Button')
    .replace(/button text (\d+)/i, 'Button Text')
    .replace(/button icon (\d+)/i, 'Button Icon');
}

export function isButtonShape(obj) {
  if (!obj?.niceName) return false;
  return (
    obj.niceName.indexOf('button rect') === 0
    || obj.niceName.indexOf('button circle') === 0
    || obj.niceName.indexOf('button ellipse') === 0
  );
}

export function isButtonText(obj) {
  return obj?.niceName && String(obj.niceName).indexOf('button text') === 0;
}

export function isPlainText(obj) {
  return obj?.name === 'text' && !isButtonText(obj);
}

export function isButtonIcon(obj) {
  return obj?.name === 'icon' || (obj?.niceName && String(obj.niceName).indexOf('button icon') === 0);
}

/** Resolve button shape + label text from any selected button part (shape, text, or icon). */
export function resolveButtonPair(selection) {
  if (!selection) return { shape: null, text: null };
  if (isButtonShape(selection)) {
    return { shape: selection, text: selection.textObj || null };
  }
  if (isButtonText(selection)) {
    return { shape: selection.textObj || null, text: selection };
  }
  if (isButtonIcon(selection) && selection.textObj) {
    const text = selection.textObj;
    return { shape: text?.textObj || null, text };
  }
  return { shape: null, text: null };
}

export function isStickerObject(obj) {
  return obj?.name === 'sticker' || obj?.niceName === 'sticker';
}

export function isUploadedImage(obj) {
  if (!obj) return false;
  if (isStickerObject(obj)) return false;
  return obj.name === 'image' || obj.niceName === 'image';
}

export function countButtons(fc) {
  let n = 0;
  fc?.forEachObject((obj) => {
    if (isButtonShape(obj)) n += 1;
  });
  return n;
}

export function deleteObjectWithLinks(fc, activeObject) {
  if (!activeObject) return;
  if (activeObject.niceName === 'generated text') return;
  if (activeObject.editable === false) return;

  let obj = activeObject.textObj;
  while (obj && obj !== activeObject) {
    fc.remove(obj);
    obj = obj.textObj;
  }
  fc.remove(activeObject);
  fc.discardActiveObject();
  fc.renderAll();
}

export function toggleVisibility(obj) {
  if (!obj) return;
  if (obj.visible) {
    obj.set({
      visible: false,
      evented: false,
      selectable: false,
      hasBorders: false,
      hasControls: false,
    });
  } else {
    obj.set({
      visible: true,
      evented: true,
      selectable: true,
      hasBorders: true,
      hasControls: true,
    });
  }
}

export function toggleLock(obj) {
  if (!obj) return;
  const locked = !obj.locked;
  obj.set({
    locked,
    lockMovementX: locked,
    lockMovementY: locked,
    lockScalingX: locked,
    lockScalingY: locked,
    lockRotation: locked,
    hasControls: !locked,
    selectable: !locked,
    evented: !locked,
  });
}

export function reorderObject(fc, fromIndex, toIndex) {
  const objects = fc.getObjects();
  const obj = objects[fromIndex];
  if (!obj || fromIndex === toIndex) return;

  if (toIndex > fromIndex) {
    for (let i = 0; i < toIndex - fromIndex; i += 1) fc.bringForward(obj);
  } else {
    for (let i = 0; i < fromIndex - toIndex; i += 1) fc.sendBackwards(obj);
  }
  fc.renderAll();
}

export function toolForSelection(obj) {
  if (!obj) return null;
  if (isButtonShape(obj) || isButtonText(obj) || isButtonIcon(obj)) return 'buttons';
  if (isStickerObject(obj)) return 'stickers';
  if (isUploadedImage(obj)) return 'googleMap';
  if (isPlainText(obj)) return 'text';
  if (
    obj.niceName === 'shape'
    || obj.name === 'shape'
    || obj.name === 'editable'
    || obj.name === 'entryfield'
    || obj.niceName === 'orgbanner'
  ) {
    return 'shapes';
  }
  return 'shapes';
}

export function stickerUrl(category, index) {
  const ext = category.type === 'svg' ? 'svg' : 'png';
  const base = `${process.env.PUBLIC_URL || ''}/pixie/assets/images/stickers/${category.name}`;
  return `${base}/${index}.${ext}`;
}

export function iconUrl(index) {
  return `${process.env.PUBLIC_URL || ''}/pixie/assets/images/stickers/icons/${index}.svg`;
}
